import { useEffect } from 'react'

import { actionsSelector, useStore } from '@liveHelper/models/store'
import { ONE_TO_ONE_STORE_PERSIST_KEY } from '@liveHelper/models/store/libs/persistInLocalStorage'

function isValidClientControls(clientControls?: {
  cameraEnabled?: unknown
  microphoneMuted?: unknown
}): boolean {
  return (
    typeof clientControls?.cameraEnabled === 'boolean' &&
    typeof clientControls?.microphoneMuted === 'boolean'
  )
}

/**
 * Updates state in the oneToOne store for values that should be "persisted"
 * when those values are changed in a different tab.
 */
export function useCrossTabStatePersist() {
  const { setClientControls } = useStore(actionsSelector)

  useEffect(() => {
    function onStorageEvent(event: StorageEvent) {
      if (event.key === ONE_TO_ONE_STORE_PERSIST_KEY) {
        const value = JSON.parse(event.newValue ?? '{}')
        const clientControls = value.state?.clientControls
        if (isValidClientControls(clientControls)) {
          setClientControls(clientControls)
        }
      }
    }

    window.addEventListener('storage', onStorageEvent)
    return () => window.removeEventListener('storage', onStorageEvent)
  }, [setClientControls])
}
